import { BaseRecord } from "./BaseRecord";
import { Category } from "./Category";
import { Client } from "./Client";
import { DieDetails } from "./DieDetails";
import { Tenant } from "./Tenant";

export class Die extends BaseRecord<number> {
    public no!: string;
    public name!: string;
    public photoUrl!: string; // existing image path or URL
    public photoBase64?: string = ''; // new base64 image data when user selects a new photo

    public categoryId !: number;
    public category: Category | null;

    public tenantId !: number;
    public tenant: Tenant | null;

    public clientId !: number;
    public client!: Client | null;

    public dieDetails: DieDetails[] = [];

    constructor() {
        super();
        this.id = 0;
        this.no = "";
        this.name = "";
        this.photoUrl = "";

        this.categoryId = 0;
        this.category = new Category();

        this.tenantId = 0;
        this.tenant = new Tenant();

        this.clientId = 0;
        this.client = new Client();

        this.dieDetails = [];
    }
}
